
<template>
  <!--社区app配置-->
  <div>
    <x-tabula
      :dataSource="dataSource"
      rowKey="application_id"
      :searchList="searchList"
      :columns="columns"
      :tableOptList="tableOptList"
      :rowOptList="rowOptList"
      :searchParams.sync="searchParams"
      :listApi="listApi"
      :addHandleParam="addHandleParam"
      :deleteParam="deleteParam"
      :rowSelection="false"
    >
      <template slot="opt_t" slot-scope="{row}">
        <img :style="{width: '30px', height: '30px'}" :src="row.icon_url" alt="">
      </template>
    </x-tabula>

    <!--同步应用功能的弹窗-->
    <a-modal
      title="同步应用功能"
      :visible="visible"
      @ok="isSubmit=true"
      @cancel="visible=false"
      :confirmLoading="btnLoading.loading"
      v-bind="$store.state.modalConfig"
    >
      <x-simpleForm
        @updateIsSubmit="isSubmit=$event"
        :isSubmit="isSubmit"
        :btnLoading="btnLoading"
        :formList="formList"
        :addParam="addParam"
      >
      </x-simpleForm>
    </a-modal>
  </div>
</template>

<script>
import mixin from '../../js/mixins';
export default {
  mixins: [mixin.fetchSelect, mixin.addEdit],
  name: 'application',
  data () {
    return {
      appTypeObj: {
        communityApp: { app_type: 2 },
        stewardApp: { app_type: 1 }
      },
      visible: false,
      isSubmit: false,
      btnLoading: { loading: false },

      searchList: [
        { props: ['keywords'], placeholder: '应用名称', inputType: 'input' },
        { props: ['status'], placeholder: '请选择状态', options: this.$store.state.statusList, inputType: 'select' }
      ],
      tableOptList: [
        { text: '新增', icon: 'plus', key: 'addbtn' },
        { text: '同步应用功能', icon: 'cloud-download', handle: this.openModal, key: 'sync' }
      ],
      rowOptList: [
        { text: '', customRender: true, handle: row => this.statusChange(row), key: 'status' },
        {
          text: '修改', handle: row => {
            this.$children.forEach((el) => {
              if (el.hasOwnProperty('toEdit')) {
                el.toEdit(row);
              }
            });
          },
          key: 'edit'
        },
        { text: '编辑功能', handle: row => this.toEditFun(row), key: 'editFun' },
        [
          { text: '删除', handle: row => this.$children[0].showDeleteConfirm(row), key: 'delete' }
        ]
      ],
      columns: [
        { title: '应用名称', dataIndex: 'title', align: 'left', width: '' },
        { title: '应用识别符', dataIndex: 'unique_mark', align: 'left', width: '' },
        { title: '应用图标', dataIndex: 'icon', align: 'left', width: '', scopedSlots: {customRender: 'action_t'} },
        { title: '排序', dataIndex: 'sort', align: 'left', width: '' },
        { title: '应用平台', dataIndex: 'platform', align: 'left', width: '' },
        { title: '默认应用', dataIndex: 'is_default', align: 'left', width: '' },
        { title: '创建时间', dataIndex: 'create_time', align: 'left', width: '' },
        { title: '状态', dataIndex: 'status_str', align: 'left', width: '' },
        { title: '操作', dataIndex: 'action', align: 'left', width: '', scopedSlots: {customRender: 'action'} }
      ],
      dataSource: [],
      searchParams: {
        keywords: '',
        status: '',
        app_type: ''
      },
      listApi: {
        url: '/application',
        resHandle: this.resHandle, // this.resHandle
        searchHandle: '' // searchHandle
      },
      addHandleParam: {
        route: () => {
          return this.$route.name === 'communityApp' ? 'addCommunityApp' : 'addStewardApp';
        },
        title: '修改社区app应用'
      },
      deleteParam: {
        url: '/application',
        param: {pk_key: 'application_id', pk_val: ''},
        title: '应用',
        key: 'title'
      },

      formList: [
        {
          label: '应用范围',
          inputType: 'select',
          options: this.$store.state.userRange,
          handle: this.handleUserRange,
          placeholder: '请选择应用范围',
          props: ['scope_type', {
            rules: [{required: true, message: '请选择应用范围'}]
          }]
        },
        {
          label: '选择城市',
          inputType: 'treeSelect',
          options: [],
          placeholder: '请选择城市',
          treeCheckable: true,
          key: 'city',
          props: ['city_scope', {
            rules: [{required: true, message: '请选择城市'}]
          }]
        },
        {
          label: '选择小区',
          inputType: 'transfer',
          options: [],
          placeholder: '',
          titles: ['小区列表', '已选'],
          key: 'community',
          props: ['community_scope', {
            rules: [{required: true, message: '请选择小区'}]
          }]
        }
      ],
      addParam: {
        url: `/sync/action/to/community`,
        reqHandle: this.addReqHandle,
        resHandle: this.addResHandle
      }
    };
  },
  created () {
    this.searchParams = {...this.searchParams, ...this.appTypeObj[this.$route.name]};
  },
  mounted () {
  },
  methods: {
    /* 打开弹窗 */
    openModal () {
      this.visible = true;
      this.$nextTick(() => {
        this.userRangeList(1, 2);
      });
    },
    /* 处理用户范围 */
    handleUserRange (val) {
      let userTypeObj = {
        0: { city: false, community: false },
        1: { city: true, community: false },
        2: { city: false, community: true }
      };
      this.handleDynamicForm(val, userTypeObj);
    },
    /* 状态切换 */
    statusChange (row) {
      let status = row.status === 1 ? 0 : 1;
      this.$put({
        url: `/application/${row.application_id}`,
        params: { status: status }
      }).then((res) => {
        this.$message.success('切换成功！');
        this.$children[0].getTableList();
      });
    },
    /* 进入编辑功能 */
    toEditFun (row) {
      let routeObj = {
        communityApp: 'editCommunityFun',
        stewardApp: 'editStewardFun'
      };
      this.setLocal('scopeArray', row.scope_array);
      console.log('row.scope_array: ', row.scope_array);
      this.$router.push({
        name: routeObj[this.$route.name],
        query: {
          id: `${row.application_id}`,
          android: `${row.android}`,
          ios: `${row.ios}`,
          scope_type: `${row.scope_type}`
        }
      });
    },
    addReqHandle (param) {
      param = this.rangeReqVal(param);
      param = {...param, ...this.appTypeObj[this.$route.name]};
      return param;
    },
    addResHandle () {
      this.visible = false;
      this.$message.success('同步应用功能成功！');
    },
    resHandle (res) {
      res.forEach((el) => {
        let arr = [];
        el.android && arr.push('Android');
        el.ios && arr.push('iOS');
        el.platform = arr.join(' | ');
        el.is_default = el.is_default === 1 ? '是' : '否';
      });
      return res;
    },
    searchHandle (selectData) {
      console.log('处理搜索数据: ', selectData);
      // return selectData;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/package/pageCompo/application.vue